<template>
  <section class="chapter3">
    <div class="container">
      <div class="panel">
        <Count>3</Count>
        <Title light>Het Grote Checken</Title>
        <Content light>
          <p>Dat we veel terugsturen en dat het veel kost is duidelijk. Maar het meest geheimzinnige is wat er nou precies gebeurt met kleding die we terugsturen.</p>
          <p>Met andere woorden: hoe ‘nieuw’ is dat nieuwe shirt dat je besteld hebt nou eigenlijk als we zo veel retourneren? We hebben heel veel webshops gebeld of we mochten komen filmen, maar bijna niemand wilde dat.</p>
          <p>Toch is het wel gelukt. We mochten filmen bij een zogenoemde kwaliteitscontrole, bij de mensen die besluiten of een geretourneerd kledingstuk opnieuw de webshop in mag. Wat zijn de gekste dingen die zij tegenkomen?</p>
        </Content>
        <CheckVideo />
        <HoleSeparation />
        <Accordion
          v-if="accordion"
          v-bind="accordion"
        />
      </div>
    </div>
    <TrianglesSeparator />
  </section>
</template>

<script>
import { Title, Count, Content } from '@/components/chapter'
import Accordion from '@/components/accordion'
import HoleSeparation from '@/components/HoleSeparation'
import { chapterMixin } from '@/mixins'
import CheckVideo from '@/components/CheckVideo'
import TrianglesSeparator from '@/components/TrianglesSeparator'

export default {
  name: 'Chapter3',
  data () {
    return {
      accordion: {
        track: 'chapter-3-accordion',
        title: 'Wat gebeurt er met de retouren die niet door de keuring komen?',
        content: 'In het buitenland gaan wel eens hele partijen in de verbrandingsoven, maar de meeste experts zeggen dat dat in Nederland amper gebeurt - in ieder geval bij mode. Neem bijvoorbeeld Zalando: daar zeggen ze dat 97 procent terug de winkel ingaat, en volgens het bedrijf wordt slechts 0,05 procent van de retourzendingen vernietigd. De rest belandt in outlets of gaat via opkopers de wereld over. Maar: echt harde, onafhankelijke cijfers zijn er niet. Wel spraken we meerdere mensen die vermoeden dat er meer vernietigd wordt dan bekend is.'
      }
    }
  },
  mixins: [chapterMixin],
  components: {
    Title,
    Count,
    Content,
    Accordion,
    HoleSeparation,
    CheckVideo,
    TrianglesSeparator
  }
}
</script>

<style lang="scss" scoped>
.chapter3 {
  padding-top: 2em;
  background-color: $c-brown;
}

.panel {
  max-width: 360px;
  background-color: white;
  margin: 0 auto;
  border-radius: 10px;
  padding: 70px 18px 20px; // + 6px = $column-padding

  @media (min-width: 768px) {
    max-width: 500px;
  }
}
</style>
